module.exports = new __parcel__URL__("cornershop-design-principles.1da6c63e.webp").toString();